module.exports = __webpack_public_path__ + "static/switcher-02bea7df22991817fdd189953f8d68d8.jpg";